export default __webpack_public_path__ + "static/media/Wagner Oliveira_.4cf701d5.png";